function initHeroSlider() {
  document.querySelectorAll(".rf-hero.swiper").forEach((slider) => {
    if (slider.swiper) return;

    const autoplayEnabled = slider.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(slider.dataset.speed, 14) || 6000;

    const progressSvg = slider.querySelector(".autoplay-progress svg");
    const progressButton = slider.querySelector(".autoplay-progress");

    const pauseIcon = slider.querySelector(".icon-pause");
    const playIcon = slider.querySelector(".icon-play");

    let isPaused = false;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      speed: 800,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        invert: false,
        sensitivity: 1,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },

      observer: true,
      observeParents: true,
      observeSlideChildren: true,

      autoplay: autoplayEnabled
        ? {
            delay: autoplaySpeed,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        : false,

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },

      on: {
        autoplayTimeLeft(swiper, time, progress) {
          if (progressSvg) {
            progressSvg.style.setProperty("--progress", 1 - progress);
          }
        },

        init() {
          updateIcons();
        },

        autoplayStart() {
          isPaused = false;
          updateIcons();
        },

        autoplayPause() {
          isPaused = true;
          updateIcons();
        },

        autoplayResume() {
          isPaused = false;
          updateIcons();
        },

        autoplayStop() {
          isPaused = true;
          updateIcons();
        },
      },
    });

    function updateIcons() {
      if (!pauseIcon || !playIcon) return;

      if (isPaused) {
        pauseIcon.hidden = true;
        playIcon.hidden = false;
      } else {
        pauseIcon.hidden = false;
        playIcon.hidden = true;
      }
    }

    if (progressButton && autoplayEnabled) {
      progressButton.addEventListener("click", function (e) {
        e.preventDefault();

        if (isPaused) {
          swiper.autoplay.resume();
        } else {
          swiper.autoplay.pause();
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initHeroSlider);
document.addEventListener("shopify:section:load", initHeroSlider);
document.addEventListener("shopify:section:reorder", initHeroSlider);